import { render, staticRenderFns } from "./DirectorSalaryPrevious.vue?vue&type=template&id=b3faca10"
import script from "./DirectorSalaryPrevious.vue?vue&type=script&lang=js"
export * from "./DirectorSalaryPrevious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports